import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { AdminListingDto, AdminTagDto } from 'services/data-contracts';
import { useNavigate } from 'react-router-dom';
import { Row } from 'saladsoft-primitive';
import Text from 'components/commons/Text';
import ServiceHelper from 'stores/ServiceHelper';

interface ListItemProps {
  listing: AdminListingDto;
}

const ListItem = ({ listing }: ListItemProps) => {
  const navigate = useNavigate();
  const [tags, setTags] = useState<AdminTagDto[]>([]);

  useEffect(() => {
    if (listing) {
      ServiceHelper?.adminListingService?.getTagsByListing1(listing?.id as number).then((res) => {
        setTags(res.data);
      });
    }
  }, [listing]);

  return (
    <ItemContainer
      key={listing.id}
      onClick={() => {
        navigate(`/admin/listings/${listing.id}/photos`);
      }}
    >
      <ActiveWrapper active={listing.isActive}>
        <Row>
          <>{listing?.isActive && <>운영중</>}</>
        </Row>
      </ActiveWrapper>
      <ItemLayout>
        <Row
          width="100%"
          justifyContent="flex-start"
          alignItems="flex-start"
          gap="30px"
          height={'100%'}
          background="#fff"
        >
          <ImageWrapper>
            <img
              src={listing?.images?.[0]?.thumbnailUrl || '/images/butlerleelogo.png'}
              alt={`Image ${listing.id}`}
              className={!listing?.images?.[0]?.thumbnailUrl ? 'default-image' : ''}
              style={{
                width: !listing?.images?.[0]?.thumbnailUrl ? '200px' : '100%',
                maxWidth: 400,
                height: '100%',
                maxHeight: 230,
                objectFit: 'cover',
              }}
            />
          </ImageWrapper>
          <div style={{ padding: 10, marginTop: 20 }}>
            <Row width="100%" justifyContent="space-between">
              <Text type="H2">{listing?.localizedName?.['ko']}</Text>
            </Row>
            <Text type="H3" style={{ fontWeight: 400, margin: '10px 0' }}>
              {listing?.localizedTitle?.['ko']?.replace(/\\r\\n/g, '')}
            </Text>
            <Row gap="10px" justifyContent="flex-start" marginBottom="10px">
              {tags.map((tag) => (
                <TagWrapper key={tag.id}>#{tag.localizedName?.['ko']}</TagWrapper>
              ))}
            </Row>

            <Text type="H5" buttonRole="DESCRIPTION">
              {listing?.localizedAddress?.['ko']}
            </Text>
            <div>
              {listing?.hostawayId ? (
                <HostawayIdWrapper>
                  HA - <b>{listing?.hostawayId}</b>
                </HostawayIdWrapper>
              ) : (
                <></>
              )}
            </div>
          </div>
        </Row>
      </ItemLayout>
    </ItemContainer>
  );
};

const ImageWrapper = styled.div`
  width: 100%;
  max-width: 400px;
  height: 100%;
  text-align: center;
  background: #efefef;
  > img {
    margin: auto;
  }
`;

const ItemContainer = styled.div`
  width: 100%;
  transition: transform 0.1s ease-in-out;
  cursor: pointer;
  position: relative;
  margin-bottom: 20px;
  border-radius: 20px;
  overflow: hidden;

  &:hover {
    transform: scale(1.01);
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  }

  @media (max-width: 1200px) {
    width: calc((100% - 20px) / 2);
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const ItemLayout = styled.div`
  border-radius: 10px;
  overflow: hidden;
  height: 230px;
  background-color: #f0f0f0;
  position: relative;

  img.default-image {
    opacity: 0.4;
    display: block;
    object-fit: contain !important;
  }
`;

const ActiveWrapper = styled.div<{ active?: boolean }>`
  position: absolute;
  top: 10px;
  right: 10px;
  border-radius: 10px;
  color: white;
  font-weight: 700;
  background: ${(props) => (props.active ? '#7c0000' : 'transparent')};
  padding: 5px 10px;
  z-index: 1;
  /* background: red !important; */
`;

const HostawayIdWrapper = styled.div`
  background: #e7e7e7;
  padding: 5px 10px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 400;
  margin-top: 20px;
  display: inline-block;
`;

const TagWrapper = styled.div`
  background: #fffbde;
  padding: 5px 10px;
  border-radius: 10px;
  display: inline-block;
`;

export default ListItem;
